import * as React from 'react';

import { Checkbox, CheckboxProps } from './checkbox';
import { Label } from './label';
import { cn } from './utils';

export interface CheckboxWithLabelProps extends CheckboxProps {
  label: string | React.ReactNode;
  /** Set key on input component when using ReactNode label. This is needed if using multiple CheckboxWithLabel's that have ReactNode labels. */
  inputKey?: string;
  classNameCheckbox?: string;
}

const CheckboxWithLabel = React.forwardRef<
  React.ElementRef<typeof Checkbox>,
  CheckboxWithLabelProps
>(
  (
    { label, inputKey, className, classNameCheckbox, ...props }: CheckboxWithLabelProps,
    ref
  ) => {
    const inputId =
      typeof label === 'string' ? label.replaceAll(/\s+/g, '') : (inputKey ?? 'checkbox');
    const labelId = inputId + '-label';
    return (
      <Label
        id={labelId}
        htmlFor={inputId}
        className={cn('group body flex cursor-pointer items-center gap-2', className)}
      >
        <Checkbox
          {...props}
          className={classNameCheckbox}
          aria-labelledby={labelId}
          id={inputId}
          ref={ref}
        />
        {typeof label === 'string' ? (
          <p
            className={cn('body', {
              'cursor-not-allowed text-flexcar-neutral80': props.disabled,
            })}
          >
            {label}
          </p>
        ) : (
          label
        )}
      </Label>
    );
  }
);
CheckboxWithLabel.displayName = 'CheckboxWithLabel';

export { CheckboxWithLabel };
